<script>
  import { createEventDispatcher } from "svelte";
  import Icon from "./Icon.svelte";

  export let id = undefined;
  export let icon = undefined;
  export let bump = false;
  export let tooltip = "";
  export let size = "larger";
  export let iconStyle = "regular";
  export let style = undefined;
  export let transparent = true;
  export let text = undefined;
  export let elucidation = undefined;
  export let enabled = true;
  export let height = "normal";
  export let stateful = false;
  export let state = "up";

  const dispatch = createEventDispatcher();

  function onClick(event) {
    if (stateful) {
      state = state === "up" ? "down" : "up";
      dispatch("state-change", { id: id, state: state });
    }
    if (enabled) {
      dispatch("click", id);
    }
  }

  function getStyle(st, tr) {
    if (st !== undefined) {
      switch (st) {
        case "highlight":
          return "button-highlight";
        case "transparent":
          return "transparent-background";
        default:
          return "";
      }
    }
    if (tr !== undefined && tr) {
      return "transparent-background";
    }

    return "";
  }
</script>

<button
  disabled={!enabled}
  title={!!elucidation ? elucidation : text}
  class:statedown={state === "down"}
  class:enabled
  class:small={height === "small"}
  class:bump
  class="button {getStyle(style, transparent)}"
  on:click={onClick}
>
  <Icon {size} {icon} style={iconStyle} {tooltip} />
  {#if text !== undefined}
    <span class="button-text" class:button-visibility={!!icon}>{text}</span>
  {/if}
</button>

<style>
  .button {
    color: var(--accent-color);
    -webkit-appearance: none;
    border-radius: 5px;
    border-width: 1px;
    background-color: white;
    height: 37px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 250ms ease-in-out;
  }

  .button-highlight {
    background-color: var(--accent-color);
    color: white;
    border: none;
  }

  .transparent-background {
    background-color: transparent;
    border-color: transparent;
  }

  .small {
    height: 20px;
  }

  .bump {
    margin-left: 5px;
  }

  .enabled.button:hover {
    background-color: var(--background-select);
    border-color: #ddd;
    cursor: pointer;
  }

  .statedown.button {
    background-color: var(--background-select);
    border-color: #ddd;
    cursor: pointer;
    color: var(--theme-color);
  }

  .button-text {
    margin-left: 0.5rem;
  }

  @media screen and (max-width: 500px) {
    .button-visibility {
      display: none;
    }
  }
</style>
